import { useEditor, useNode } from '@craftjs/core';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { SliderField } from '../SliderField/SliderField';
import type { PageProps } from '@builder4/shared/components/Page';

export const NodeGapSettingsV2 = () => {
  const { nodeProps, id, displayName } = useNode((node) => ({
    id: node.id,
    nodeProps: node.data.props,
    displayName: node.data.displayName,
  }));

  const { actions } = useEditor();
  const { getBPProp, setBPProp } = useBreakpointAwareProp(displayName);

  const gap = getBPProp(nodeProps, 'gap') ?? 10;

  const updateGap = (value: number, skipHistory = false) => {
    const actionMethod = skipHistory ? actions.history.ignore().setProp : actions.setProp;
    actionMethod(id, (props: Partial<PageProps>) => {
      setBPProp(props, 'gap', value);
    });
  };

  const handleOnChangeGap = (e: number) => {
    updateGap(e, true);
  };

  const handleOnChangeGapComplete = (value: number, initialValue: number) => {
    updateGap(initialValue, true);
    updateGap(value);
  };

  return (
    <SliderField
      label="Gap"
      value={gap}
      onChange={handleOnChangeGap}
      onChangeComplete={handleOnChangeGapComplete}
      min={0}
      max={100}
      step={1}
    />
  );
};
